/**
 * Maps an array of strings to an array of objects with `label` and `value` properties.
 * 
 * @param {string[]} spList - The input array of strings to be transformed.
 * @returns {{ label: string; value: string }[]} - An array of objects where each object contains `label` and `value` properties derived from the input strings.
 */
export const formatSPList = (spList: string[]): Array<any> => {
  try {
    if (Array.isArray(spList)) {
      return spList.map((spName: any) => ({
        label: spName,
        value: spName,
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
